import { createContext } from 'react';
import { SortType } from './AdvancedTable';

export type TableContextType = {
  sortOrder: SortType;
  sortProperty: string;
  onChangeSorting?: Function;
  currentPage: number;
  pageSize: number;
  pageSizeRange: number[];
  totalCount: number;
  onChangeCurrentPage?: Function;
  onChangePageSize?: Function;
  totalPages: number;
  onMountColumn: Function;
  onUnmountColumn: Function;
};

export const TableContext = createContext<TableContextType>({
  sortOrder: 'asc',
  sortProperty: '',
  onChangeSorting: undefined,
  currentPage: 1,
  pageSize: 100,
  pageSizeRange: [100],
  totalCount: 0,
  totalPages: 1,
  onChangeCurrentPage: undefined,
  onChangePageSize: undefined,
  onMountColumn: undefined,
  onUnmountColumn: undefined,
});
